import langIt from './lang-it.json'
import { locale, loadMessages } from 'devextreme/localization'

export default function (components) {
  return {
    name: 'App',

    components: components,
    created() {
      loadMessages(langIt)
      locale(navigator.language)
    },
    data: () => ({
      //
    }),
  }
}
